<template>
    <div id="babyTicket">
        <div class="title">审核管理 > 亲子票务管理 > <span class="title-detail" @click="$router.go(-1)"> 评价列表</span></div>
        <el-card class="main">
            <div class="query-form">
                <el-form :model="formInline" ref="ruleForm" label-width="100px">
                    <el-form-item label="客户名称：">
                        <el-input v-model="formInline.name" placeholder="请输入用户ID/账号"></el-input>
                    </el-form-item>
                    <el-form-item label="评分排序：">
                        <el-select v-model="formInline.order" placeholder="请选择">
                            <el-option label="时间倒叙" :value="0"></el-option>
                            <el-option label="评分正序" :value="1"></el-option>
                            <el-option label="评分倒叙" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                        <el-button type="primary" @click="query">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="table">
                <el-table :data="tableData" style="width: 100%; min-height: 450px;" v-loading="loading">
                    <el-table-column prop="spu_name" label="景区名称"></el-table-column>
                    <el-table-column prop="user_name" label="客户名称"></el-table-column>
                    <el-table-column prop="sku_name" label="门票名称"></el-table-column>
                    <el-table-column prop="start_tag" label="评价分数"></el-table-column>
                    <el-table-column prop="content" label="评价内容"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="details(scope.row)">查看详情</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                 <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
        </el-card>
    </div>
</template>

<script>
import { getEvaluationList } from '@/api/baby/evaluation.js'
export default {
    data () {
        return {
            loading: false,
            formInline: {
                order: 0,
                name: ''
            },
            data: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
        }
    }, 
    computed: {
        tableData () {
            return this.data
        }
    },
    methods: {
        handleSizeChange (page) {
            this.pageSize = page;
            this.initTable();
        },
        handleCurrentChange (page) {
            this.currentPage = page;
            this.initTable();
        },
        details (row) {
            let id = row.id,
                sku_name = row.sku_name;
            this.$router.push({path: '/home/baby-ticket-appraise-details', query: {id, sku_name}})
        },
        resetForm(formName) {
            this.formInline.name = '';
            this.formInline.order = 0;
            this.initTable();
            // this.$refs[formName].resetFields();
        },
        query () {
            this.currentPage = 1;
            this.initTable();
        },
        initTable () {
            this.loading = true;
            let params = {
                ...this.$route.query,
                name: this.formInline.name,
                order: this.formInline.order,
                page: this.currentPage,
                limit: this.pageSize
            }
            getEvaluationList(params)
                .then(res => {
                    if (res.data.code == 0) {
                        this.data = res.data.data.data;
                        this.total = res.data.data.total;
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    this.loading = false;
                })
        }
    },
    created () {
        this.initTable();
    }
}
</script>

<style lang="scss" scoped>
    #babyTicket {
        min-width: 1260px;
        .title {
            box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
            width: 100%;
            background: #fff;
            padding: 15px 32px;
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #000;
            font-weight: 600;
            .title-detail {
                margin-left: 5px;
                color: rgb(109, 109, 109);
                cursor: pointer;
            }
            p {
                font-size: 16px;
                color: #333;
                margin-left: 32px;

                span {
                    color: #e72f0d;
                    padding: 0 5px;
                }

                &:first-child {
                    font-size: 18px;
                    color: #333;
                    margin-left: 0;
                }

                &:nth-child(2) {
                    span {
                        color: #2448ff;
                    }
                }
            }
        }
        .main {
            margin: 24px;
            border-radius: 0;
        }
        .query-form {
            .el-form {
                display: flex;
                justify-content: space-between;
            }
        }
        .table {
            margin: 0px 24px 24px 24px;
        }
    }

    ::v-deep .el-pagination {
        margin-top: 12px;
        float: right;
        margin-bottom: 24px;
    }

    ::v-deep .el-form-item {
        flex: 1;
    }

    ::v-deep .el-select {
        width: 100%;
    }

    ::v-deep .el-dialog__header {
        border-bottom: 1px solid #F1F1F1;
        font-weight: bold;
    }
    
    ::v-deep .el-dialog {
        border-radius: 10px;
        min-width: 580px;
    }

    ::v-deep .el-dialog__footer {
        border-top: 1px solid #F1F1F1;
        padding: 10px 20px 10px;
    }

    ::v-deep .el-dialog__body {
        padding: 60px 80px;
    }
</style>